import { BASE_URL } from 'config';
import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import PaymentConfigsTableData from "./data/payment_configTableData";
import TextField from "@mui/material/TextField";
import MDButton from "components/MDButton";
import AddPayment_configdModal from "components/AddPayment_configModal";
import AddIcon from "@mui/icons-material/Add";
import { Height } from "@mui/icons-material";
import { width } from "@mui/system";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PaymentMethodCard from "./components/PaymentMethodCard";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import RowsPerPageSelector from "components/RowsPerPageSelector";

function PaymentConfigs() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleEditClick = (user) => {
    setCurrentUser(user);
    setModalOpen(true);
    console.log("user", user);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(
        BASE_URL + "/administrator/payment-methods-configs",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      setUsers(data.data || []);
      console.log(data.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
    setLoading(false);
  };

  const { columns, rows } = PaymentConfigsTableData(users, handleEditClick, fetchUsers);

  const filteredRows = rows.filter((row) =>
    row.author.props.name.toLowerCase().includes(search.toLowerCase())
  );

  const paginatedRows = filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  useEffect(() => {
    setPage(0); // تصفير الصفحة عند تغيير البحث أو عدد الصفوف
  }, [search, rowsPerPage]);

  return (
    <>
      <Backdrop open={loading} sx={{ zIndex: 2000, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <AddPayment_configdModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setCurrentUser(null);
        }}
        onUserAdded={fetchUsers}
        initialData={currentUser}
      />

      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              قائمة طرق الدفع
            </MDTypography>

            <MDButton
              variant="contained"
              color="white"
              startIcon={<AddIcon />}
              sx={{ color: "white" }}
              onClick={() => setModalOpen(true)}
            >
              طريقة دفع جديدة
            </MDButton>
          </MDBox>

          <MDBox pt={3} px={2}>
            <TextField
              fullWidth
              label="بحث بالاسم "
              variant="outlined"
              size="small"
              sx={{ mb: 3 }}
              onChange={(e) => setSearch(e.target.value)}
            />
            {/* مكون اختيار عدد الصفوف */}
            <MDBox mb={2} display="flex">
              <RowsPerPageSelector value={rowsPerPage} onChange={setRowsPerPage} />
            </MDBox>
            <MDBox display="flex" flexWrap="wrap" gap={2}>
              {paginatedRows.map((row) => (
                <PaymentMethodCard key={row.id} paymentMethod={row} />
              ))}
            </MDBox>

            {/* Pagination controls */}
            <MDBox display="flex" justifyContent="center" mt={4} pb={4} px={2}>
              <MDButton
                onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
                disabled={page === 0}
                sx={{
                  background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                  color: "white",
                  borderRadius: "50%",
                  width: "50px",
                  height: "50px",
                  minWidth: "50px",
                  mx: 1,
                  "&:hover": {
                    background: "linear-gradient(90deg, #b6842f, #d39d45)",
                  },
                }}
              >
                <ArrowBackIcon />
              </MDButton>

              <MDTypography
                variant="button"
                color="text"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mx: 3,
                  fontWeight: "bold",
                }}
              >
                الصفحة {page + 1} من {Math.ceil(filteredRows.length / rowsPerPage)}
              </MDTypography>

              <MDButton
                onClick={() =>
                  setPage((prev) =>
                    (prev + 1) * rowsPerPage >= filteredRows.length ? prev : prev + 1
                  )
                }
                disabled={(page + 1) * rowsPerPage >= filteredRows.length}
                sx={{
                  background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                  color: "white",
                  borderRadius: "50%",
                  width: "50px",
                  height: "50px",
                  minWidth: "50px",
                  mx: 1,
                  "&:hover": {
                    background: "linear-gradient(90deg, #b6842f, #d39d45)",
                  },
                }}
              >
                <ArrowForwardIcon />
              </MDButton>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>

    </>
  );
}

export default PaymentConfigs;
